import { gql } from '@apollo/client'

export const DebitCardTransactionsV2FragmentDoc = gql`
  fragment DebitCardTransactionsV2Fragment on DebitCardTransactionV2 {
    __typename
    attachments
    cardAcceptorName
    amount {
      value
    }
    debitCardName
    id
    debitCardAccountUuid
    debitCardId
    debitCardMaskedPan
    description
    category
    subcategory
    subcategoryDetails {
      id
      name
      predefined
    }
    status
    timestamp
    reference
    referencePayee
    type
    note
    tags
    contact {
      businessName
      category
      contactType
      firstName
      id
      lastName
      isSelf
      icon {
        colour
        images {
          size
          url
        }
        letter
      }
    }
    merchant {
      __typename
      id
      name
      icon {
        images {
          size
          url
        }
        colour
        letter
      }
      address {
        country
        postcode
        state
        street1
        street2
        suburb
      }
      hours
      phone
      email
      url
      abn
      location
      locationAccuracy
    }
    payerDetails {
      accountDetails {
        bsb
        account
        name
      }
      debitCardAccount {
        id
        name
        icon {
          colour
          letter
          image
          images {
            size
            url
          }
          animation
        }
        type
      }
      debitCardAccountUuid
      paymentInstrumentUuid
      senderUuid
    }
    payeeDetails {
      accountDetails {
        bsb
        account
        name
      }
      bpayDetails {
        billerName
        billerCode
        crn
        nickname
      }
      debitCardAccount {
        id
        name
        icon {
          colour
          letter
          image
          images {
            size
            url
          }
          animation
        }
        type
      }
      debitCardAccountUuid
      paymentInstrumentUuid
    }
  }
`
export const GetDebitCardTransactions = gql`
  query GetDebitCardTransactions(
    $limit: Int!
    $filter: DebitCardTransactionFilterInputV2
    $nextToken: DebitCardTransactionV2NextTokenInput
  ) {
    getDebitCardTransactionsV2(
      limit: $limit
      filter: $filter
      nextToken: $nextToken
    ) {
      transactions {
        ...DebitCardTransactionsV2Fragment
      }
      nextToken {
        id
        entityUuid
        type
      }
    }
  }

  ${DebitCardTransactionsV2FragmentDoc}
`

export const GetDebitCardTransactionAttachmentUploadUrls = gql`
  query GetDebitCardTransactionAttachmentUploadUrls(
    $fileNames: [String]!
    $transactionUuid: ID!
  ) {
    getDebitCardTxnAttachmentUploadUrls(
      fileNames: $fileNames
      transactionUuid: $transactionUuid
    ) {
      fileName
      uploadUrl
      documentUuid
    }
  }
`

export const GetDebitCardTransactionSummary = gql`
  query GetDebitCardTransactionSummary(
    $transactionUuid: ID!
    $timeZone: String
  ) {
    getDebitCardTransactionSummary(
      debitCardTransactionUuid: $transactionUuid
      timeZone: $timeZone
    ) {
      downloadLink
      expire
    }
  }
`

export const GetAccountTransactionFiltersContacts = gql`
  query GetAccountTransactionFiltersContacts(
    $limit: Int!
    $filter: ContactFilterInput
    $nextToken: String
  ) {
    getContacts(limit: $limit, filter: $filter, nextToken: $nextToken) {
      contacts {
        id
        businessName
        firstName
        lastName
        contactType
      }
      nextToken
    }
  }
`

export const GetDebitCardTransactionAttachmentDownloadUrls = gql`
  query GetDebitCardTransactionAttachmentDownloadUrls($transactionUuid: ID!) {
    getDebitCardTxnAttachmentDownloadUrls(transactionUuid: $transactionUuid) {
      downloadUrl
      fileName
      contentType
      documentUuid
    }
  }
`
